//  actions
import TYPES from './types'

//  initialState
import initialState from './initialState'

// Model
import model from './model'

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SELECTOR.UPDATE:
      return model.update(state, action.payload)
    case TYPES.SELECTOR.RESET:
      return model.reset(initialState)
    default:
      return state
  }
}
